var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header_logo"}},[_c('b-link',{attrs:{"to":{ name: 'index' }}},[_c('b-img',{staticClass:"header_image",attrs:{"fluid":true,"src":_vm.imagePath}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }